export const MEDIA_SECTION_VIMEO_VIDEO_LINK =
  'https://vimeo.com/1078623605/19f48e7699';
